window.detachBattery = function (customerSlug = "", batteryId) {
    // TODO: add translations
    showPopup(
        "Weet je het zeker?",
        "Weet je zeker dat je deze batterij wilt ontkoppelen?",
        "Ontkoppelen",
        "Annuleren",
        function () {
            axios({
                method: "PUT",
                url:
                    "/customers/" +
                    customerSlug +
                    "/batteries/" +
                    batteryId +
                    "/detach",
            })
                .then(function (res) {
                    window.location.href = "/customers/" + customerSlug;
                })
                .catch(function (ex) {
                    console.log("exception", ex);
                });
        }
    );
};
